var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTableDots = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 5.83329C10.7292 5.83329 11.6667 4.89579 11.6667 3.74996C11.6667 2.60413 10.7292 1.66663 9.58333 1.66663C8.4375 1.66663 7.5 2.60413 7.5 3.74996C7.5 4.89579 8.4375 5.83329 9.58333 5.83329Z",
    fill: "#23252F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 7.91663C8.4375 7.91663 7.5 8.85413 7.5 9.99996C7.5 11.1458 8.4375 12.0833 9.58333 12.0833C10.7292 12.0833 11.6667 11.1458 11.6667 9.99996C11.6667 8.85413 10.7292 7.91663 9.58333 7.91663Z",
    fill: "#23252F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 14.1666C8.4375 14.1666 7.5 15.1041 7.5 16.25C7.5 17.3958 8.4375 18.3333 9.58333 18.3333C10.7292 18.3333 11.6667 17.3958 11.6667 16.25C11.6667 15.1041 10.7292 14.1666 9.58333 14.1666Z",
    fill: "#23252F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTableDots);
export default ForwardRef;